import { z } from "zod";

export const getVehicleDataByVinResponseSchema = z.object({
  cardHolderName: z.string(),
  companyUuid: z.uuid(),
  driverFirstName: z.string(),
  driverLastName: z.string(),
});

export type GetVehicleDataByVinResponse = z.infer<
  typeof getVehicleDataByVinResponseSchema
>;
